var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancellation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3083 26.2502L15.1667 22.1085L16.8 20.4752L19.2792 22.9543L24.2375 17.996L25.8708 19.6585L19.3083 26.2502ZM8.63333 19.8335L7 18.2002L8.86667 16.3335L7 14.4668L8.63333 12.8335L10.5 14.7002L12.3667 12.8335L14 14.4668L12.1333 16.3335L14 18.2002L12.3667 19.8335L10.5 17.9668L8.63333 19.8335ZM5.83333 25.6668C5.19167 25.6668 4.64256 25.4386 4.186 24.982C3.72944 24.5254 3.50078 23.9759 3.5 23.3335V7.00016C3.5 6.3585 3.72867 5.80938 4.186 5.35283C4.64333 4.89627 5.19244 4.66761 5.83333 4.66683H7V2.3335H9.33333V4.66683H18.6667V2.3335H21V4.66683H22.1667C22.8083 4.66683 23.3578 4.8955 23.8152 5.35283C24.2725 5.81016 24.5008 6.35927 24.5 7.00016V14.4085L22.1667 16.771V11.6668H5.83333V23.3335H13.125L15.4292 25.6668H5.83333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellation);
export default __webpack_public_path__ + "static/media/cancellation.1f5849a53fcd9113670ec503b0e4325c.svg";
export { ForwardRef as ReactComponent };